import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { helpHttp } from "../../helpers/helpHttp";
import { BASE_API } from "../../api/Globals";
import { DataView } from "primereact/dataview";
import { Tooltip } from "primereact/tooltip";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";
import { ProgressBar } from "primereact/progressbar";
import XMLParser from 'react-xml-parser';
import { storage } from "../../helpers/storage";

const DialogEditarEvidencia = (
    {
        visible = false,
        onHide = () => { },
        data = null,
        esAdministrador = false

    }
) => {

    const [banderaReturn, setBanderaReturn] = useState(false);
    const [documentos, setDocumentos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [template, setTemplate] = useState('original');
    const [loadingVerId, setLoadingVerId] = useState(null);

    const [openDialogConfirmar, setOpenDialogConfirmar] = useState(false);

    const [file, setFile] = useState('');

    const [files, setFiles] = useState([]);
    const [totalArchivos, setTotalArchivos] = useState(0);
    const [loadingUpload, setLoadingUpload] = useState(false)

    const [eliminarItem, setEliminarItem] = useState(null);
    const [loadingEliminarId, setLoadingEliminarId] = useState(null);
    const [loadingEliminar, setLoadingEliminar] = useState(false)

    const [mostrarProgresoEvidencias, setMostrarProgresoEvidencias] = useState(false);
    const [evidenciasProceso, setEvidenciasProceso] = useState([]);
    const [cargandoEvidencias, setCargandoEvidencias] = useState(false);
    const [pausado, setPausado] = useState(false);
    const [pausaSolicitada, setPausaSolicitada] = useState(false);

    const ciclo = storage.get('ciclo');
    const id = storage.get('id');
    const toast = useRef(null);
    const isPDF = (file) => file.type === 'application/pdf';
    const canPreviewPDF = (file) => file.size <= 3000000; // 3MB
    const perfil = storage.get('perfilid');
    const pausaRef = useRef(false)

    const total = evidenciasProceso.length;
    const done = evidenciasProceso.filter(e => e.status === 'done' || e.status === "error").length;
    const progreso = total ? Math.round((done / total) * 100) : 0;
    const procesoCompletado = total > 0 && done === total;

    const [totalExitosos, setTotalExitosos] = useState(0);
    const [totalErrores, setTotalErrores] = useState(0);

    useEffect(() => {
        if (visible && data !== null) {
            if (!esAdministrador) {
                obtenerAdjuntos(data)
            } else {
                obtenerAdjuntosCT(data)
            }
        } else {
            setFiles([]);
            setFile('');
            setTotalArchivos(0);
            setBanderaReturn(false)
            setTemplate('original')
        }
    }, [visible, data]);

    useEffect(() => {
        if (template === 'A' || template === 'B') {
            setBanderaReturn(true);
        } else {
            setBanderaReturn(false);
        }
    }, [template]);

    useEffect(() => {
        return () => {
            files.forEach(file => URL.revokeObjectURL(file));
        };
    }, [files]);

    const obtenerAdjuntosCT = (detalle) => {
        setLoading(true)
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "SpdListarEvidenciasCTMaquila",
                opcion: 0,
                parametros: [
                    { "Folio": detalle["Folio maquila"] },
                    { "CCT": detalle["Clave CT"] },
                    { "IdCicloEscolar": ciclo.IdCicloEscolar }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                const data = res.ITEMS.map(x => {
                    return {
                        ...x,
                        TipoArchivo: x.tipoArchivo,
                        idFolioMaquila: x.Folio,
                        IdCicloEscolar: x.idCicloEscolar,
                    }
                })
                setDocumentos(data)
                setLoading(false);
            }
        })
    }

    const obtenerIdTarea = async (detalle) => {
        try {
            const response = await helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
                body: {
                    'sp': 'spdGetIdTareaFolioMaquila',
                    'opcion': 2,
                    'parametros': [
                        { 'idCicloEscolar': ciclo.IdCicloEscolar },
                        { 'idFolioMaquila': detalle.idFolioMaquila },
                        { 'Codigo': !esAdministrador ? data.Codigo : data['Clave CT'] }
                    ]
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS && res.ITEMS.length > 0) {
                    return res.ITEMS[0].idTareaFolioMaquila
                } else {
                    return null
                }
            });
            return response;
        } catch (err) {
            console.warn(err)
            return false
        }
    }

    const obtenerFolioMaquila = async (detalle) => {
        const data = await helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "spdGetFolioMaquila",
                tipo: 1,
                parametros: [
                    { "IdUsuario": id },
                    { "IdEstatus": 0 },
                    { "FiltroValor": detalle['Folio maquila'] },
                    { "NumPagina": 0 },
                    { "NumRegistros": 500 },
                    { "IdCicloEscolar": ciclo.IdCicloEscolar }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                return res.ITEMS;
            } else {
                return null;
            }
        })

        return data;
    }

    const obtenerAdjuntos = (data) => {
        setLoading(true)
        helpHttp().post(`${BASE_API}Usuarios/EvidenciaMaquila`, {
            body: {
                "Opcion": "S",
                "CicloEscolar": "",
                "TipoMaquila": "",
                "TipoArchivo": "",
                "RutaArchivo": "",
                "id": null,
                "IdUsuario": id,
                "NombreArchivo": "",
                "Folio": data.idFolioMaquila,
                "FechaCreate": new Date().toISOString(),
                "Activo": true,
                "Archivo": "",
                "IdCicloEscolar": ciclo.IdCicloEscolar,
                "parametrosExtra": `[{"idFolio": ${data.idFolioMaquila}, "idTarea": ${data.idTarea}}]`
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }

        }).then(res => {
            if (res.SUCCESS) {
                setDocumentos(res.ITEMS);
                setLoading(false);
            }
        })
    }

    const obtenerArchivo = async (contenido) => {
        setLoadingVerId(contenido.id)
        const respuesta = await helpHttp().post(`${BASE_API}Usuarios/EvidenciaMaquila`, {
            body: {
                "Opcion": "O",
                "CicloEscolar": "",
                "TipoMaquila": "",
                "TipoArchivo": "",
                "RutaArchivo": "",
                "id": contenido.id,
                "IdUsuario": id,
                "NombreArchivo": "",
                "Folio": contenido.Folio,
                "FechaCreate": new Date().toISOString(),
                "Activo": true,
                "Archivo": "",
                "IdCicloEscolar": contenido.IdCicloEscolar,
                "parametrosExtra": `[{"idFolio": ${contenido.Folio}, "idTarea": ${contenido.TipoMaquila}}]` //se usan estos campos como provicionales
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                return res.ITEMS
            }
        }).finally(() => {
            setLoadingVerId(null)
        })
        return respuesta
    }

    const AbrirArchivo = (contenido) => {
        const linkSource = contenido.Archivo
        const bytes = base64toBlob(linkSource)
        if (bytes !== null) {
            if (contenido.TipoArchivo.toLowerCase() !== ".pdf") {
                let imgData = contenido.Archivo
                setFile(
                    "<img width='100%' height='100%' src=" + imgData + " />"
                )
                setTemplate('B');
            } else {
                if (bytes.size < 1500000) {
                    setFile(
                        "<iframe width='100%' height='100%' src='" + linkSource + "'></iframe>"
                    )
                    setTemplate('B');
                } else {
                    toast.current.show({ severity: 'success', summary: 'Aviso', detail: 'El archivo es demasiado grande para abrirlo, se ha descargado.', life: 9000 });
                    const downloadLink = document.createElement('a')
                    const fileName = contenido.NombreArchivo
                    downloadLink.href = linkSource
                    downloadLink.download = fileName
                    downloadLink.click();
                }
            }
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Archivo en proceso de guardado, intente más tarde.", life: 5000 })
        }
    }

    const base64toBlob = (data) => {
        // console.log(data)
        try {
            if (data !== null) {
                const matches = data.match(/^data:(.+);base64,(.*)$/);

                const mimeType = matches[1]; // Extract the MIME type
                const base64 = matches[2]; // Extract the Base64 data

                const bytes = atob(encodeURI(base64))
                let lenght = new Array(bytes.length)
                for (let i = 0; i < lenght; i++) {
                    lenght[i] = bytes.charCodeAt(i)
                }
                const byteArray = new Uint8Array(lenght)
                return new Blob([byteArray], { type: mimeType })
            } else {
                return null;
            }
        } catch (err) {
            console.warn("Error: ", err)
            return null;
        }


    }

    const toBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result
            .replace('data:', '')
            .replace(/^.+,/, ''));
        reader.onerror = reject;
    });

    const handleUpload = async () => {
        if (files.length !== 0) {
            setLoadingUpload(true)
            const formateo = await Promise.all(
                files.map(async (adjunto) => {
                    const base64 = await toBase64(adjunto);
                    return {
                        name: adjunto.name,
                        type: adjunto.type,
                        size: adjunto.size,
                        base64: base64,
                    }
                })
            );
            const hasError = formateo.some((file) => !['image/jpeg', 'image/png', 'application/pdf'].includes(file.type));
            if (hasError) {
                setLoadingUpload(false)
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Solo se permiten archivos: PNG, JPG, JPEG y PDF.", life: 5000 })
                return;
            }
            const lista = inicializarProgresoEvidencias();
            setEvidenciasProceso(lista)
            setMostrarProgresoEvidencias(true);
            await new Promise(resolve => setTimeout(resolve, 0));
            await handleAdjuntos();
            setLoadingUpload(false);
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Favor de llenar los campos obligatorios.", life: 5000 })
        }
    }

    const handleGetLink = async (detalle) => {
        const data = await helpHttp().post(`${BASE_API}/Dinamico/ConsultaDinamica`, {
            body: {
                'sp': "spdGetLinksFolioMaquila",
                'tipo': 0,
                'parametros': [
                    { "IdCicloEscolar": ciclo.IdCicloEscolar },
                    { "IdFolioMaquila": detalle.idFolioMaquila },
                    { "IdTipoUsuario": storage.get('perfilid') },
                    { "IdUsuario": id },
                ]
            },
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Accept': 'application/json',
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then((res) => {
            if (res.SUCCESS) {
                var xml = (new XMLParser().parseFromString(res.ITEMS[0].AtributosLinksdelListado));
                if (xml.children[0].children.length === 2) {
                    return true;
                }
                else {
                    return false;
                }
            } else {
                return null;
            }
        });
        return data;
    }

    const handleGestionMaquila = async (detalle) => {
        try {
            const datos = await helpHttp().post(`${BASE_API}Entrega/postSpdGuardarMovimientoFolioMaquila`, {
                body: {
                    "idFolioMaquila": detalle.idFolioMaquila,
                    "idUsuario": id,
                    "IdResolucion": 7,
                    "IdCicloEscolar": ciclo.IdCicloEscolar,
                    "Valor": "",
                    "parametrosExtras": `[{ "NombreArchivos": "${files.map(a => a.name).join(";")}", "codigo": ${'"' + data['Clave CT'] + '"'} }]`
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => res.ITEMS);

            return datos

        } catch (err) {
            return false;
        }
    }

    const formatBytes = (bytes, decimals = 2) => {
        const mb = bytes / (1024 * 1024);
        return mb.toFixed(2) + " MB";
    }

    const inicializarProgresoEvidencias = () => {
        return files.map(adj => ({
            name: adj.name,
            size: adj.size,
            status: 'pending' // pending | uploading | done | error
        }));
    };

    const pausarCarga = () => {
        pausaRef.current = true;
        setPausaSolicitada(true);
    }

    const reanudarCarga = async () => {
        pausaRef.current = false;
        setPausado(false);
        setPausaSolicitada(false);
        setCargandoEvidencias(true);

        await handleAdjuntos()
    }

    const evaluarResultadoFinal = (lista) => {

        const total = lista.length;

         const exitosos = lista.filter(e => e === 'done').length;
         const errores = lista.filter(e => e === 'error').length;
    
         setTotalExitosos(exitosos);
         setTotalErrores(errores);


        if (exitosos === total) {
            toast.current.show({
                severity: 'success',
                summary: 'Aviso',
                detail: 'Todos los archivos se subieron correctamente.',
                life: 5000
            });
            return;
        }

        if (exitosos > 0 && errores > 0) {
            toast.current.show({
                severity: 'warn',
                summary: 'Aviso',
                detail: 'Algunos archivos se subieron correctamente y otros no pudieron subirse.',
                life: 6000
            });
            return;
        }

        if (errores === total) {
            toast.current.show({
                severity: 'error',
                summary: 'Aviso',
                detail: 'No se pudo subir ningún archivo.',
                life: 6000
            });
            return;
        }
    };

    const obtenerDetalleFolio = async (detalle) => {
        const respuesta = await helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "SpdConsultarDetalleMaquila",
                tipo: 0,
                parametros: [
                    { idFolio: detalle.idFolioMaquila },
                    { idUsuario: id },
                    { idUsuarioTipo: perfil },
                    { IdCicloEscolar: ciclo.IdCicloEscolar }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                return res.ITEMS
            } else {
                return [];
            }
        })
        return respuesta;
    }

    const handleAdjuntos = async () => {
        try {
            let dataBandera = null;
            let detalleBandera = null;
            let evidenciaBandera = null;

            // 🔐 Flujo especial para administrador
            if (esAdministrador) {
                dataBandera = await obtenerFolioMaquila(data);

                if (!dataBandera) {
                    toast.current.show({
                        severity: 'warn',
                        summary: 'Aviso',
                        detail: 'No fue posible obtener el folio de maquila.',
                        life: 5000,
                    });
                    setLoadingUpload(false);
                    return;
                }

                detalleBandera = await obtenerDetalleFolio(dataBandera)

                if (!detalleBandera) {
                    toast.current.show({
                        severity: 'warn',
                        summary: 'Aviso',
                        detail: 'No fue posible obtener el detalle de maquila.',
                        life: 5000,
                    });
                    setLoadingUpload(false);
                    return;
                }

                const esGestion = await obtenerIdTarea(dataBandera);
                evidenciaBandera = esGestion

                if (esGestion === false) {
                    toast.current.show({
                        severity: 'warn',
                        summary: 'Aviso',
                        detail: 'No fue posible validar la gestión de la maquila.',
                        life: 5000,
                    });
                    setLoadingUpload(false);
                    return;
                }

                if (esGestion === null) {
                    const gestionOk = await handleGestionMaquila(dataBandera);
                    evidenciaBandera = gestionOk;
                    if (gestionOk?.succes === false) {
                        toast.current.show({
                            severity: 'warn',
                            summary: 'Aviso',
                            detail: 'Error al gestionar la maquila.',
                            life: 5000,
                        });
                        setLoadingUpload(false);
                        return;
                    }
                }
            }

            const formateo = await Promise.all(
                files.map(async (adjunto) => {
                    const base64 = await toBase64(adjunto);
                    return {
                        name: adjunto.name,
                        type: adjunto.type,
                        size: adjunto.size,
                        base64,
                    };
                })
            );

            setCargandoEvidencias(true);
            let resultados = [];
            let resultadosNombres = [];

            for (let i = 0; i < formateo.length; i++) {
                if (pausaRef.current) {
                    setCargandoEvidencias(false);
                    setPausado(true);
                    setPausaSolicitada(false);
                    return;
                }

                if (evidenciasProceso[i]?.status === 'done') {
                    continue;
                }

                setEvidenciasProceso(prev =>
                    prev.map((e, idx) =>
                        idx === i ? { ...e, status: 'uploading' } : e
                    )
                );
                const res = await helpHttp().post(`${BASE_API}Usuarios/EvidenciaMaquila`, {
                    body: {
                        "Opcion": "C",
                        "CicloEscolar": ciclo.Descripcion,
                        "TipoMaquila": "",
                        "TipoArchivo": (`.${formateo[i].name.split('.').pop()}`),
                        "RutaArchivo": "",
                        "id": null,
                        "IdUsuario": id,
                        "NombreArchivo": formateo[i].name,
                        "Folio": data.idFolioMaquila,
                        "FechaCreate": new Date().toISOString(),
                        "Activo": true,
                        "Archivo": formateo[i].base64,
                        "IdCicloEscolar": ciclo.IdCicloEscolar,
                        "parametrosExtra": `[{"idFolio": ${!esAdministrador ? data.idFolioMaquila : dataBandera.idFolioMaquila}, "idTarea": ${!esAdministrador ? data.idTarea : evidenciaBandera.idTarea ? evidenciaBandera.idTarea : evidenciaBandera}, "idTipoUsuario": ${perfil}, "codigo": "${!esAdministrador ? data.Codigo : data['Clave CT']}", "idTipoMaquila": "${!esAdministrador ? data.idTipoMaquila : dataBandera.idTipoMaquila}", "nombreArchivos": "${resultadosNombres.join(";")}", "opcionOriginal": "${!esAdministrador ? "C2" : evidenciaBandera.idTarea ? "C1" : "C2"}" }]`
                    },
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                });

                if (res.SUCCESS) resultadosNombres.push(formateo[i].name);
                resultados.push(res.SUCCESS ? 'done' : 'error')

                setEvidenciasProceso(prev =>
                    prev.map((e, idx) =>
                        idx === i ? { ...e, status: res.SUCCESS ? 'done' : 'error' } : e
                    )
                );

                if (pausaRef.current) {
                    setCargandoEvidencias(false);
                    setPausado(true);
                    setPausaSolicitada(false);
                    return;
                }

                if (!res.SUCCESS) {
                    continue;
                };
            }
            setCargandoEvidencias(false);

            if (!pausaRef.current) {
                evaluarResultadoFinal(resultados);
            }

        } catch (error) {
            console.error(error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Ocurrió un error inesperado.',
                life: 5000,
            });
        } finally {
            setLoadingUpload(false);
        }
    };

    const handleConfirmar = async (item) => {
        if (documentos.length > 1 || ![16].includes(perfil)) {
            setLoadingEliminarId(item.id); // 🔥 loading SOLO este item

            try {
                setOpenDialogConfirmar(true);
                const respuesta = await obtenerArchivo(item);
                setEliminarItem(respuesta);
            } finally {
                setLoadingEliminarId(null); // 🔥 apagar loading
            }
        } else {
            toast.current.show({ severity: 'warn', summary: "Aviso", detail: "No se puede eliminar. Debe existir al menos un archivo de evidencia.", life: 5000 })
        }

    }

    const confirmarEliminacion = async (item) => {
        setLoadingEliminar(true)
        const dataBandera = esAdministrador ? await obtenerFolioMaquila(data) : null;

        helpHttp().post(`${BASE_API}Usuarios/EvidenciaMaquila`, {
            body: {
                "Opcion": "E",
                "CicloEscolar": ciclo.Descripcion,
                "id": item.id,
                "IdUsuario": id,
                "Folio": !esAdministrador ? data.idFolioMaquila : dataBandera.idFolioMaquila,
                "FechaCreate": new Date().toISOString(),
                "IdCicloEscolar": ciclo.IdCicloEscolar,
                "parametrosExtra": `[{"idFolio": ${!esAdministrador ? data.idFolioMaquila : dataBandera.idFolioMaquila}, "idTarea": ${!esAdministrador ? data.idTarea : '"-"'}, "codigo": ${esAdministrador ? '"' + data['Clave CT'] + '"' : `"${data.Codigo}"`}}]`
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                setOpenDialogConfirmar(false);
                setEliminarItem(null);
                if (!esAdministrador) {
                    obtenerAdjuntos(data);
                } else {
                    obtenerAdjuntosCT(data);
                }
                toast.current.show({ severity: 'success', summary: "Aviso", detail: "Archivo eliminado correctamente.", life: 5000 })
            } else {
                setOpenDialogConfirmar(false);
                setEliminarItem(null);
                toast.current.show({ severity: 'warn', summary: "Aviso", detail: res.MESSAGE, life: 5000 })
            }
        }).finally(() => {
            setLoadingEliminar(false)
        })
    }

    const RenderTemplate = () => {
        switch (template) {
            default:
                return <EvidenciasTemplate />
            case 'A':
                return <UploadTemplate />
            case 'B':
                return <DocumentTemplate />
        }
    }

    const backTemplate = () => {
        switch (template) {
            case 'A':
                setBanderaReturn(false);
                setFiles([]);
                setEvidenciasProceso([]);
                setMostrarProgresoEvidencias(false);
                setPausado(false);
                pausaRef.current = false;
                return setTemplate('original');
            case 'B':
                setBanderaReturn(false);
                return setTemplate('original');
        }
    }

    const cancelUpload = () => {
        setFiles([]);
        setTotalArchivos(0);
        if (!esAdministrador) {
            obtenerAdjuntos(data)
        } else {
            obtenerAdjuntosCT(data);
        }
        backTemplate(template);
    }

    const onFilesSelect = (e) => {
        const selectedFiles = Array.from(e.target.files);

        const nuevos = selectedFiles.filter(f =>
            (f.size <= 20000000 || (toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `"${f.name}" supera los 20MB`, life: 5000 }), false)) &&
            (!files.some(prev => prev.name === f.name) || (toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `"${f.name}" duplicado`, life: 5000 }), false))
        );

        if (nuevos.length > 0) {
            setFiles(prev => [...prev, ...nuevos]);
            setTotalArchivos(prev => prev + nuevos.length);
        }

        // reset para poder volver a seleccionar el mismo archivo
        e.target.value = '';
    };

    const onDropFiles = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        onFilesSelect({ target: { files: droppedFiles } });
    };

    const listTemplate = (item) => {

        const date = item.FechaCreate ? item.FechaCreate : item.fechaCreacion

        return (
            <div className="col-12 xl:col-3 lg:col-4 md:col-6 sm:col-6 p-2 text-center">

                <div style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px', borderRadius: '15px' }}>
                    <br />
                    <Tooltip target=".nombreArchivolabel" mouseTrack mouseTrackLeft={10} />
                    <i className='pi pi-image' style={{ fontSize: '40px', marginTop: '15px' }} />
                    <br />
                    <div className='nombreArchivolabel' data-pr-tooltip={item.NombreArchivo} style={{ color: 'black', fontWeight: 'bold', fontSize: '16px', marginTop: '5px' }}>{item.NombreArchivo.substring(0, 16).toLowerCase()}..{item.TipoArchivo}</div>
                    {/* <div style={{ color: 'black', marginTop: '5px' }}>Tipo {item.TipoArchivo }</div> */}
                    <div style={{ color: 'black', marginTop: '5px' }}>Ciclo {item.CicloEscolar}</div>
                    <div style={{ color: 'black', marginTop: '5px' }}>{new Date(date).toLocaleDateString('en-GB')}</div>
                    <div style={{ color: 'black', fontSize: '11px', marginTop: '5px' }} />
                    <br />
                    <div className="col-12">
                        <Button className="p-button p-component" loading={loadingVerId === item.id} style={{ marginBottom: '10px', width: '64%', justifyContent: 'center' }} onClick={async () => {
                            const respuesta = await obtenerArchivo(item)
                            AbrirArchivo(respuesta)
                        }}>Ver</Button>

                        {(perfil !== 16 || item.HabilitarEdicion) && <Button className="p-button-outlined p-component" loading={loadingEliminarId === item.id} style={{ marginBottom: '10px', width: '64%', justifyContent: 'center' }} onClick={() => handleConfirmar(item)}>Eliminar</Button>}
                    </div>
                </div>
            </div>
        )
    }

    const FileListTemplate = () => (
        <div className="grid mt-3">
            {files.map((file, index) => {
                const fileURL = URL.createObjectURL(file);

                return (
                    <div key={index} className="col-12 flex xl:px-5 lg:px-5 md-px-5 sm:px-5">
                        {/* PREVIEW */}
                        <div className="col-7 xl:col-6 lg:col-6 md:col-6 sm:col-6 flex align-items-center" style={{ overflowWrap: 'anywhere' }}>
                            {/* Imagen */}
                            {file.type.startsWith('image/') && (
                                <img
                                    src={fileURL}
                                    alt={file.name}
                                    width={100}
                                    style={{ borderRadius: '6px' }}
                                />
                            )}

                            {/* PDF */}
                            {isPDF(file) && canPreviewPDF(file) && (
                                <iframe
                                    src={fileURL}
                                    title={file.name}
                                    width="100"
                                    height="120"
                                    style={{ border: '1px solid #ccc', borderRadius: '6px' }}
                                />
                            )}

                            {/* ZIP / RAR / PDF grande */}
                            {(!file.type.startsWith('image/') &&
                                (!isPDF(file) || !canPreviewPDF(file))) && (
                                    <i
                                        className="pi pi-file"
                                        style={{ fontSize: '3rem', color: '#555' }}
                                    />
                                )}

                            <span className="text-left ml-3">
                                {file.name}
                                <small> {new Date().toLocaleDateString('en-GB')}</small>
                            </span>
                        </div>


                        <div className="col-5 xl:col-6 lg:col-6 md:col-6 sm:col-6 flex align-items-center" style={{ justifyContent: 'space-between' }}>
                            {/* TAG SIZE */}
                            <div className="align-content-center text-center">
                                <Tag
                                    value={`${(file.size / 1024 / 1024).toFixed(2)} MB`}
                                    severity={file.size > 3000000 ? 'danger' : 'warning'}
                                    className="px-3 py-2 mr-2"
                                />
                            </div>

                            {/* BUTTON DELETE */}
                            <div className="align-content-center text-right">
                                <Button
                                    icon="pi pi-times"
                                    className="p-button-rounded p-button-outlined p-button-danger ml-auto"
                                    disabled={loadingUpload}
                                    onClick={() => {
                                        setFiles(prev => prev.filter((_, i) => i !== index));
                                        setTotalArchivos(prev => prev - 1);
                                    }}
                                />
                            </div>
                        </div>


                    </div>
                );
            })}
        </div>
    );

    const EvidenciasTemplate = () => {
        return <div className="grid">
            <div className="col-12">
                <div className="flex" style={{ justifyContent: 'right' }}>
                    {/* {archivos !== null && <label className="mr-3" style={{ fontWeight: '600', fontSize: '15px' }} > {archivos.length + ' de ' + limiteArchivos + ' archivos límite'}</label>} */}
                    <Button
                        type='button'
                        name="button-abrirArchivo"
                        id="button-generar"
                        // disabled={archivos !== null && archivos.length >= limiteArchivos}
                        icon={('' ? 'pi pi-spin pi-spinner' : 'pi pi-plus')}
                        label="Cargar evidencia"
                        onClick={() => setTemplate('A')}
                    />
                </div>
                <div className="mt-4 grid">
                    {loading !== true ? documentos !== null && documentos.length > 0 &&
                        <DataView
                            className="w-full"
                            value={documentos}
                            emptyMessage="No se encontraron resultados"
                            itemTemplate={listTemplate} />
                        :
                        <div className="col-12 text-center">
                            <ProgressSpinner />
                        </div>}

                    {documentos !== null && documentos.length === 0 &&
                        <div className="col-12 text-center" style={{ fontSize: '15px', marginBottom: '20px' }}> Aún no hay archivos cargados</div>
                    }

                </div>
            </div>
        </div>
    }

    const valueTemplate = (value) => {
        return (
            <React.Fragment>
                <span style={{ color: 'black', fontWeight: 400, fontSize: '14px', textShadow: 'black 0px 0px' }}>{done} / {total}</span>
            </React.Fragment>
        );
    };

    const UploadTemplate = () => {
        return (mostrarProgresoEvidencias ?
            <div className="p-8">
                <Tooltip target=".target-tooltip" />

                {progreso == 100 ? (
                    <h5>Evidencias procesadas</h5>
                ) :
                    (<h5> Subiendo evidencias...</h5>)
                }

                <ProgressBar value={progreso} displayValueTemplate={valueTemplate} />
                {/* <small>{done} de {total} evidencias guardadas</small> */}

                {progreso == 100 &&
                    <p>
                        <span> {totalExitosos} guardadas correctamente</span>
                        <span style={{ fontSize: '18px', fontWeight: 'bold', marginLeft: '5px', marginRight: '5px' }}>·</span>
                        <span>{totalErrores} con error </span>
                    </p>}

                <div className="mt-5 p-2 pt-3" /*style={{border: '1px solid #505050', borderRadius: '10px'  height: '40vh', overflowY: 'scroll' }}*/>
                    <ul>
                        {evidenciasProceso.map((e, i) => (
                            <li key={i} className="flex align-items-center gap-3 mb-2">
                                {e.status === 'done' && <i className="pi pi-check-circle text-green-500 target-tooltip" data-pr-tooltip='Guardado' style={{ fontSize: '20px' }} />}
                                {e.status === 'uploading' && <i className="pi pi-spin pi-spinner text-black-500 target-tooltip" data-pr-tooltip='Subiendo' style={{ fontSize: '20px' }} />}
                                {e.status === 'pending' && <i className="pi pi-circle text-gray-400 target-tooltip" data-pr-tooltip='Pendiente' style={{ fontSize: '20px' }} />}
                                {e.status === 'error' && <i className="pi pi-times-circle target-tooltip" data-pr-tooltip='Error' style={{ fontSize: '20px', color: 'red' }} />}
                                <div>
                                    <span style={{ fontWeight: 600 }}>{e.name}</span>  <br />
                                    <span style={{ fontWeight: 300 }}>{formatBytes(e.size)}</span>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div> :
            <>
                <div
                    className="col-12"
                    onDragOver={(e) => e.preventDefault()}

                    onDrop={!loadingUpload && onDropFiles}
                    style={{
                        border: '2px dashed #ccc',
                        borderRadius: '10px',
                        padding: '2rem',
                        textAlign: 'center'
                    }}
                >
                    <p>Arrastra y suelta archivos aquí</p>

                    <input
                        type="file"
                        id="fileInput"
                        multiple
                        accept=".pdf,.png,.jpg,.jpeg,.zip,.rar"
                        hidden
                        onChange={onFilesSelect}
                    />

                    <Button
                        icon="pi pi-plus"
                        label="Elegir archivo"
                        disabled={loadingUpload}
                        onClick={() => document.getElementById('fileInput').click()}
                    />
                </div>

                {files.length > 0 && <FileListTemplate />}
            </>
        );
    };

    const DocumentTemplate = () => {
        console.log('file', file.substring(1,4))
        const tipoArchivo = file.substring(1,4)

        return <div style={{ width: '100%',  height: tipoArchivo == 'img' ? 'auto' : '100%', overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: file }} />
    }

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={visible} closable={false} draggable={false} blockScroll={true} contentStyle={template !== "A" && { borderBottomRightRadius: "20px", borderBottomLeftRadius: "20px" }} breakpoints={{ "800px": "100%" }} style={{ width: "80%", height: "90%" }}
                footer={template === "A" &&
                    <React.Fragment>
                        {mostrarProgresoEvidencias ?
                            <>
                                {cargandoEvidencias && !pausado && (
                                    <Button
                                        className="p-button"
                                        loading={pausaSolicitada}
                                        label="Pausar"
                                        onClick={pausarCarga}
                                    />
                                )}

                                {pausado && !procesoCompletado && (
                                    <Button
                                        className="p-button"
                                        loading={cargandoEvidencias}
                                        label="Reanudar"
                                        onClick={reanudarCarga}
                                    />
                                )}
                            </>
                            :
                            <>
                                <Button
                                    label="Cancelar"
                                    icon='pi pi-times'
                                    disabled={loadingUpload}
                                    className="p-button-outlined mb-3"
                                    onClick={cancelUpload}
                                />
                                <Button
                                    label="Guardar"
                                    icon='pi pi-check'
                                    className="p-button ml-2 mr-3 mb-3"
                                    loading={loadingUpload}
                                    onClick={() => {
                                        handleUpload();
                                    }}
                                /></>}
                    </React.Fragment>
                }
                header={
                    <div className='grid'>
                        <div className='text-left col-3'></div>
                        <div className='text-center col-6'>{template === 'B' ? 'VISUALIZACIÓN DE EVIDENCIAS' : 'EDICIÓN DE EVIDENCIAS'} </div>
                        <div className='text-right col-3 pt-0 pb-0' style={{ alignContent: 'center' }}>
                            {!cargandoEvidencias && <Button rounded text icon="pi pi-times" className="p-button-outlined text-white p-0 m-0" onClick={() => banderaReturn ? cancelUpload(template) : onHide()} />}
                        </div>
                    </div>
                }>
                {/* <BlockUI blocked={loadingUpload} fullScreen
                    template={
                        <div className="flex flex-column align-items-center gap-3">
                            <ProgressSpinner />
                            <span style={{ fontWeight: '600' }}>Subiendo archivos…</span>
                        </div>
                    }
                >
                </BlockUI> */}
                <RenderTemplate />
            </Dialog>
            <Dialog id='modalAvisoCambioCiclo'
                header="CONFIRMACIÓN"
                visible={openDialogConfirmar}
                draggable={false}
                closable={false}
                blockScroll={true}
                style={{ width: '600px', marginLeft: '10px', marginRight: '10px', height: '300px' }}
                footer={
                    <div style={{ float: "right" }}>
                        <div>
                            <Button label="NO" icon='pi pi-times' disabled={loadingEliminar ? true : false} className="p-button-outlined" onClick={() => { setOpenDialogConfirmar(false); setEliminarItem(null) }}></Button>
                            <Button label="SÍ" icon='pi pi-check' loading={loadingEliminar} className="p-button p-component" onClick={() => confirmarEliminacion(eliminarItem)}></Button>
                        </div>
                    </div>
                }>
                {eliminarItem === null && (
                    <div className="col-12 text-center">
                        <ProgressSpinner />
                        <p>Cargando archivo...</p>
                    </div>
                )}
                {eliminarItem !== null &&
                    <div className="text-center">
                        <p style={{ fontSize: '15px' }}>¿Está seguro que desea eliminar el archivo <strong>{eliminarItem.NombreArchivo}</strong>?</p>
                        {/* Imagen */}
                        {base64toBlob(eliminarItem.Archivo) !== null && base64toBlob(eliminarItem.Archivo).type.startsWith('image/') && (
                            <img
                                src={eliminarItem.Archivo}
                                alt={file.NombreArchivo}
                                width={100}
                                style={{ borderRadius: '6px' }}
                            />
                        )}

                        {/* PDF */}
                        {base64toBlob(eliminarItem.Archivo) !== null && (isPDF(base64toBlob(eliminarItem.Archivo)) && canPreviewPDF(base64toBlob(eliminarItem.Archivo))) && (
                            <iframe
                                src={eliminarItem.Archivo}
                                title={file.NombreArchivo}
                                width="100"
                                height="120"
                                style={{ border: '1px solid #ccc', borderRadius: '6px' }}
                            />
                        )}
                    </div>}
            </Dialog>
        </>
    )
};

export default DialogEditarEvidencia;